__turbopack_context__.v({
  "container": "TiktokCount-module__9FdNOq__container",
  "count": "TiktokCount-module__9FdNOq__count",
  "fadeInItems": "TiktokCount-module__9FdNOq__fadeInItems",
  "icon": "TiktokCount-module__9FdNOq__icon",
  "marquee": "TiktokCount-module__9FdNOq__marquee",
  "spacing--lg": "TiktokCount-module__9FdNOq__spacing--lg",
  "spacing--md": "TiktokCount-module__9FdNOq__spacing--md",
  "spacing--sm": "TiktokCount-module__9FdNOq__spacing--sm",
  "spacing--xl": "TiktokCount-module__9FdNOq__spacing--xl",
  "spacing--xs": "TiktokCount-module__9FdNOq__spacing--xs",
  "spacing--xxl": "TiktokCount-module__9FdNOq__spacing--xxl",
  "spacing--xxs": "TiktokCount-module__9FdNOq__spacing--xxs",
  "spacing--xxxl": "TiktokCount-module__9FdNOq__spacing--xxxl",
  "spacing--xxxs": "TiktokCount-module__9FdNOq__spacing--xxxs",
  "user": "TiktokCount-module__9FdNOq__user",
  "userText": "TiktokCount-module__9FdNOq__userText",
});
